import React from 'react';
import { UnpaidBalanceDetails } from '../../components/unpaid-balance/details';

export const UnpaidBalanceDetailsPage: React.FC = () => {
    return <UnpaidBalanceDetails />;
};
